/**
 * Truncate text with '...' at the end
 */
export const truncate = (text: string, length: number) =>
  text && text.length && text.length > length
    ? `${text.substring(0, length)}...`
    : text
